import { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import PayFrame from '../../components/PayFrame';
import { getPaymentMe, licenseLine } from '../../utils/paymentInfo';

// Admin → «Ödəniş və abunə»: canlı pay.fiscalbusiness.net səhifəsi proqramın içində.
export default function Payment() {
    const [data, setData] = useState(null);
    const [error, setError] = useState('');

    useEffect(() => {
        let alive = true;
        getPaymentMe()
            .then((d) => { if (alive) setData(d); })
            .catch((err) => { if (alive) setError(err.response?.data?.msg || 'Ödəniş səhifəsi alınmadı.'); });
        return () => { alive = false; };
    }, []);

    const license = data?.license;
    const line = licenseLine(license);
    const tone = license?.state === 'expired' || license?.state === 'disabled'
        ? 'bg-rose-50 text-rose-700 ring-rose-200'
        : Number(license?.daysLeft) <= 2 ? 'bg-amber-50 text-amber-800 ring-amber-200'
        : 'bg-emerald-50 text-emerald-700 ring-emerald-200';

    return (
        <Layout>
            <div className="flex flex-col gap-3" style={{ height: 'calc(100vh - 88px)' }}>
                <div className="flex flex-wrap items-center justify-between gap-2">
                    <div>
                        <h1 className="text-lg font-bold text-gray-900">Ödəniş və abunə</h1>
                        {data?.business_name && <p className="text-xs text-gray-500">{data.business_name}</p>}
                    </div>
                    {line && <span className={`rounded-full px-3 py-1 text-xs font-semibold ring-1 ${tone}`}>{line}</span>}
                </div>
                <div className="min-h-0 flex-1">
                    {error ? (
                        <div className="flex h-full items-center justify-center rounded-2xl border border-gray-200 bg-white p-6 text-center text-sm text-gray-500">
                            {error}
                        </div>
                    ) : (
                        <PayFrame url={data?.url} />
                    )}
                </div>
            </div>
        </Layout>
    );
}
